import { resolveCeremonyOutcome as e } from "../../logic/ceremonyOutcome.mjs";
import { parsePasskeyReturn as t } from "./parsePasskeyReturn.mjs";
import { takePasskeyReturn as n } from "./passkeyReturnSlot.mjs";
//#region src/passkeys/native/resolveNativeCeremony.ts
var r = 3e3, i = 150, a = (t, n) => e({
	verified: t.verified,
	supported: t.code !== "unsupported",
	purpose: t.purpose,
	transactionId: t.transactionId,
	resultToken: t.resultToken,
	code: t.code,
	reason: t.verified && !t.resultToken ? "no_proof" : t.code
}, t.purpose === null ? void 0 : n), o = async (e, r, { sleep: o, now: s, takeParked: c = n }, l) => {
	if (r.type === "success" && "url" in r && typeof r.url == "string") return c(e), a(t(r.url), l);
	if (r.type === "locked") return { kind: "failed" };
	let u = s();
	for (;;) {
		let t = c(e);
		if (t) return a(t, l);
		if (s() - u >= 3e3) break;
		await o(i);
	}
	return { kind: "abandoned" };
};
//#endregion
export { r as PARKED_RETURN_GRACE_MS, o as resolveNativeCeremony };
